import { useBrand } from '../BrandContext';
import { OEM_DOC_IDENTITY, type OemDocIdentity } from './doc-identity';

/** The OEM identity for the selected brand. Safe outside `BrandProvider`. */
export function useOemDocIdentity(): OemDocIdentity {
  const { brandId } = useBrand();
  return OEM_DOC_IDENTITY[brandId];
}
